
















import {Component, Vue} from "vue-property-decorator";

@Component({
  name: "testing-step-4",
})
export default class TestingStep4 extends Vue{
  mounted () {
    this.$emit('next-step-available');
  }
}
